import axios from 'axios';

// set base URL
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/',
});

// request interceptor to add Authorization token
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// response interceptor to check for 401
axiosInstance.interceptors.response.use(null, (error) => {
  try {
    // if error status is 401 remove the token and logout the user
    if (
      error?.response?.status === 401 &&
      !error?.response?.request?.responseURL?.includes('login')
    ) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }
  } catch (error) {
    console.log(error);
  } finally {
    return Promise.reject(error);
  }
});

export default axiosInstance;
